import { render } from "./EditTaskItemDialog.vue?vue&type=template&id=193c87d6"
import script from "./EditTaskItemDialog.vue?vue&type=script&lang=js"
export * from "./EditTaskItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__